<template>
    <div>
        <div class="headercontainer">
            <label class="header">Lodge an enquiry</label>
            <label class="subheader">Find out more about what's happening with your consignment.</label>
        </div>
        <div class="enquirycontainer">
            <form @submit.prevent="onSendEnquiry" class="enquiryForm">
                <div class="message" v-if="form.isSubmitted">
                    <p class="header">Your enquiry has been sent.</p>
                    <p class="subheader">Thank you for your enquiry. We will endeavour to get back to you as soon as possible. Please keep an eye on your inbox for our response.</p>
                </div>
                <div v-else-if="form.isLoading">
                    <div class="loader">
                        <div class="loader__bar"></div>
                        <div class="loader__bar"></div>
                        <div class="loader__bar"></div>
                        <div class="loader__bar"></div>
                        <div class="loader__bar"></div>
                        <div class="loader__ball"></div>
                    </div>
                </div>
                <fieldset v-else>
                    <div class="errormessage" v-if="form.isSubmittedWithError">
                        <p>Error sending email, please try again.</p>
                    </div>
                    <div class="enquiryFormFields">
                        <label class="label" for="connote">Connnote number</label>
                        <label type="text" class="field" id="connote">{{form.connote}}</label>

                        <label class="label" for="companyName">Contact details</label>
                        <input type="text" class="field" id="companyName" required placeholder="Company name*" v-model="form.companyName" oninvalid="this.setCustomValidity('Company name is required')" oninput="this.setCustomValidity('')">
                        <input type="text" class="field" id="contactName" required placeholder="Contact name*" v-model="form.contactName" oninvalid="this.setCustomValidity('Contact name is required')" oninput="this.setCustomValidity('')">
                        <input class="field" type="email" id="email" required placeholder="Email*" v-model="form.email" oninvalid="this.setCustomValidity('Email is required')" oninput="this.setCustomValidity('')">

                        <label class="label" for="preferredContactMethodEmail">Preferred contact method</label>
                        <select class="field" id="preferredContactMethodEmail" required v-model="form.isPreferredContactMethodEmail">
                            <option v-bind:value="true">Email</option>
                            <option v-bind:value="false">Telephone</option>
                        </select>
                        <input class="field" type="text" id="telephone" v-bind:required="!form.isPreferredContactMethodEmail" v-bind:style="{display: form.isPreferredContactMethodEmail ? 'none' : 'block'}"
                               placeholder="Telephone*" v-model="form.telephone" oninvalid="this.setCustomValidity('Telephone is required')" oninput="this.setCustomValidity('')">

                        <label class="label" for="enquiryType">Enquiry Details</label>
                        <select class="field" id="enquiryType" required v-model="form.enquiryType">
                            <option value="" disabled selected>Select the subject of the enquiry</option>
                            <option>Overdue Delivery</option>
                            <option>Redirection</option>
                            <option>Redelivery</option>
                            <option>Partial Delivery</option>
                            <option>Other</option>
                        </select>

                        <textarea class="message" id="enquiryDetails" required placeholder="Message*" v-model="form.enquiryDetails" oninvalid="this.setCustomValidity('Message is required')" oninput="this.setCustomValidity('')"></textarea>

                        <label class="privacy">
                            Your privacy is important to us. When you contact us, information collected by Freight Management Holdings Pty Ltd (ACN 144 724 532) and its group entities including efm Logistics Services Group Pty Ltd (ACN 144 724 685) and Flip Group Technologies Pty Ltd (ACN 607 246 042) (efm, us, we, our) will be used and held by us for the purposes of contacting you in response to your query and otherwise as specified in our <a target="_blank" href="https://www.efmlogistics.com.au/privacy">privacy policy</a>. If you choose not to provide this information, we may not be able to respond to your query. To access or change your information, please contact us using the details set out in our <a target="_blank" href="https://www.efmlogistics.com.au/privacy">privacy policy</a>.
                        </label>

                        <div class="privacyContainer">
                            <input class="privacyCheck" type="checkbox" id="terms" required v-model="form.termsState" oninvalid="this.setCustomValidity('Confirm you have read the privacy policy and terms of use')" oninput="this.setCustomValidity('')">
                            <label class="privacyText" for="terms">I have read and accept the <a target="_blank" href="https://oneflo.com.au/portal-terms/">Terms of Use</a></label>
                        </div>

                        <vue-recaptcha ref="recaptcha" @verify="onCaptchaVerified"
                                       @expired="onCaptchaExpired" :sitekey="this.sitekey" :loadRecaptchaScript="true">
                        </vue-recaptcha>

                        <button type="submit" class="btn btn-primary mb-2 btn-enquiry">Lodge Enquiry</button>
                    </div>
                </fieldset>
            </form>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import VueRecaptcha from 'vue-recaptcha';

    export default {
        props: {
            data: { type: String, default: null },
            connote: { type: String, default: null },
            sitekey: { type: String, default: null }
        },
		data() {
            return {
                form: {
                    enquiryData: "",
                    connote: "",
                    companyName: "",
                    contactName: "",
                    isPreferredContactMethodEmail: true,
                    email: "",
                    enquiryType: "",
                    enquiryDetails: "",
                    termsState: false,
                    isLoading: false,
                    isValid: false,
                    isSubmitted: false,
                    isSubmittedWithError: false
                }
			}
        },
        mounted() {
            if (this.data) {
                this.form.enquiryData = this.data
            }
            if (this.connote) {
                this.form.connote = this.connote
            }
        },
		methods:
		{
            onSendEnquiry() {
                if (this.form.isValid) {
                    this.form.isLoading = true;
                    axios.post('/Enquiry', this.form)
                        .then(() => {
                            // hide the form on success action
                            this.form.isSubmitted = true;
                        })
                        .catch(() => {
                            this.form.isSubmittedWithError = true;
                        })
                        .finally(() => {
                            this.isLoading = false;
                        });
                }
            },
            onCaptchaVerified: function (response) {
                if (response) {
                    this.form.isValid = true;
                }
            },
            onCaptchaExpired: function () {
                this.$refs.recaptcha.reset();
            }
        },
        components: { 'vue-recaptcha': VueRecaptcha }
	}
</script>

<style lang="scss" scoped>
    .headercontainer {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 286px;
        left: 0px;
        background: #F9F8F7;
    }
    .header {
        font-family: Interstate;
        font-style: normal;
        font-weight: bold;
        font-size: 58.66px;
        display: flex;
        align-items: center;
        text-align: center;
        color: #000000;
        flex: none;
        order: 0;
        flex-grow: 0;
        margin: 24px 0px;
    }
    .subheader {
        font-family: Inter;
        font-style: normal;
        font-weight: normal;
        font-size: 22.5px;
        line-height: 32px;
        text-align: center;
        color: #27374E;
        flex: none;
        order: 1;
        flex-grow: 0;
        margin: 24px 0px;
    }
    .enquirycontainer{
        padding-top: 10px;
    }
    .enquiryForm {
        font-family: Inter;
        font-size: 16px;
        width: 500px;
        padding: 15px 30px;
        border-radius: 4px;
        margin: 65px auto;
        width: 500px;
    }
    .enquiryForm input[type=text] {
        width: 500px;
    }
    .enquiryForm input[type="text"]:focus {
        border: 1px solid #D1D0D5;
    }
    .enquiryFormFields {
        flex-direction: column;
        display: flex;
        justify-content: space-between;
        height: 1100px;
    }
    .enquiryForm .label {
        font-family: Inter;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        color: #27374E;
    }
    .enquiryForm .field {
        line-height: 22px;
        background: #FFFFFF;
        border: 1px solid #D1D0D5;
        box-sizing: border-box;
        box-shadow: inset 0px 2px 2px rgba(94, 91, 106, 0.15);
        border-radius: 4px;
        min-height: 35px;
        margin: 0px;
        padding: 6px 4px 6px 10px;
        color: #5E6B7E;
        font-size: 16px;
    }
    .enquiryForm textarea {
        line-height: 22px;
        background: #FFFFFF;
        border: 1px solid #D1D0D5;
        box-sizing: border-box;
        box-shadow: inset 0px 2px 2px rgba(94, 91, 106, 0.15);
        border-radius: 4px;
        padding: 6px 4px 6px 10px;
        color: #5E6B7E;
        font-size: 16px;
        min-width: 380px;
        min-height: 120px;
        resize: vertical;
        overflow: auto;
    }
    .enquiryForm a {
        color: #5E6B7E;
    }
    .privacy {
        font-family: Inter;
        font-style: normal;
        font-weight: 500;
        font-size: 11.52px;
        line-height: 16px;
        color: #5E6B7E;
    }
    .privacyContainer {
        display: flex;
        margin-bottom: 30px;
    }
    .privacyCheck {
        width: 20px;
        height: 20px;
        margin-right: 10px;
        background: #FFFFFF;
        border: 1px solid #D1D0D5;
        box-sizing: border-box;
        border-radius: 4px;
    }
    .privacyText {
        font-family: Inter;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        color: #5E6B7E;
    }
    .btn-enquiry {
        font-family: Inter;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 8px 16px;
        line-height: 24px;
        width: 144px;
        height: 36px;
        margin: 50px 0px;
    }
    .message,
    .errormessage {
        height: 35px;
        margin: 0px;
    }

    .message .header,
    .errormessage p {
        font-family: Interstate;
        font-style: normal;
        font-weight: bold;
        font-size: 35.16px;
        line-height: 42px;
        color: #000000;
    }

    .message .subheader {
        font-family: Inter;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 28px;
        color: #27374E;
    }

    .errormessage p {
        color: #b33b3b; /* Red */
    }
</style>